<template>
  <section id="two">
    <h2>work</h2>
    <div class="row">
      <article
        class="6u 12u$(xsmall) work-item"
        v-for="entry in entries"
        v-bind:entry="entry"
        v-bind:key="entry.id"
      >
        <img :src="entry.image_source" class="image fit" />
        <h3>{{entry.headline}}</h3>
        <h3>{{entry.details}}</h3>
        <ul>
          <li v-for="duty in entry.duties" v-bind:key="duty.id">{{duty}}</li>
        </ul>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  data: function() {
    return {
      entries: [
        {
          id: 1,
          image_source: "images/amos.jpg",
          url:
            "https://www.allianz.com/en/products_solutions/global_lines/amos/",
          headline: "Allianz Managed Operations & Services SE, Munich, Germany",
          details: "01/2016 - 04/2016, Service Manager",
          duties: [
            "Create and release security specifications for hardware and software",
            "Automate order process chains and create a comprehensive reporting",
            'Design and conceptualize the "workplace of the future" in workshops with customers'
          ]
        },
        {
          id: 2,
          image_source: "images/hilti.png",
          url: "https://www.hilti.com/",
          headline:
            "Hilti Befestigungstechnik AG, Buchs St. Gallen, Switzerland",
          details: "10/2015 - 12/2015, IT-Project Manager",
          duties: [
            "Cooperate in the Windows 10 Tablet pilot project for direct sales and Hilti Center",
            "Coordinate application tests with responsible persons in business and IT",
            "Train the IT Service Desk staff on change management"
          ]
        },
        {
          id: 3,
          image_source: "images/senacor.jpeg",
          url: "https://senacor.com/",
          headline: "Senacor Technologies AG, Nuremberg, Germany",
          details: "03/2015 – 05/2015, Test-Manager",
          duties: [
            "Coordinate and execute application tests for web applications and mobile apps",
            "Analyse requirements and specify software with/for customers"
          ]
        },
        {
          id: 4,
          image_source: "images/fim.jpg",
          url: "http://www.fim-rc.de/?lang=en",
          headline:
            "Research Center Finance & Information Management, University of Augsburg",
          details: "10/2015 - 12/2015, IT-Project Manager",
          duties: [
            "Create educational material and carry out tutoring sessions for the lecture “Information Technology in Business Administration”",
            "Lead assistant responsible for the chairs IT-coordination between the Fraunhofer institute FIT and the project group “Business & Information Systems Engineering”",
            "Lead responsible for the chairs IT-helpdesk"
          ]
        }
      ]
    };
  }
};
</script>